import React from 'react'
import Popover from '@mui/material/Popover';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 200,
    },
    {
        field: 'date',
        headerName: 'Assigned Date',
        width: 120,
    },
    {
        field: 'assignee',
        headerName: 'Assignee',
        width: 180,
        renderCell: (param) => (
            <div className='profile__table-profile'>
                <h4 className="profile__table-name">{param.row.assigneeName}</h4>
                <span className="profile__table-role">{param.row.assigneeRole}</span>
            </div>
        )
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 130,
        renderCell: (param) => (
            <span className={`profile__table-status 
            ${param.row.status.toLowerCase().replace(/\s/g, '')}`}>
                {param.row.status}
            </span>
        )
    },
];

const rows = [
    {
        id: 1,
        name: 'Acer Aspire A-254',
        date: '3/27/2069',
        assigneeName: 'Kazeem Oluwafemi',
        assigneeRole: 'It Officer',
        status: 'Active',
    },
    {
        id: 2,
        name: 'Samsung Galaxy',
        date: '9/11/2085',
        assigneeName: 'Kazeem Oluwafemi',
        assigneeRole: 'It Officer',
        status: 'Under Repair',
    },
    
];

const ProfileTable = () => {
  return (
    <div className='profile__table'>
        <h4 className="profile__table-title">Assets Asigned to You</h4>

        <div className="profile__table-box">
            <DataGrid
                // getRowId={(rows => rows.date)}
                rows={rows}
                columns={columns}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 5,
                    },
                },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                getRowHeight={() => 'auto'} 
                sx={{
                    margin: 'auto',
                    maxWidth: {md: '700px', sm: '600px', xs: '400px'},
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                        py: 0.5,
                    },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                        py: '5px',
                    },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                        py: '10px',
                    },
                }}
                experimentalFeatures={{ lazyLoading: true }}
            />
        </div>
    </div>
  )
}

export default ProfileTable